<fc-progress-bar currentStep="2" *ngIf="!readOnlyMap && !isAdmin && !isLimitedAdmin"></fc-progress-bar>
<div class="container">
  <div class="main">
    <ng-container *ngIf="activeSite">
      <fc-map-layers
        (mapInitialize)="handleMapInitialize($event)"
        (generateMap)="confirmSiteMapCreation()"
        [drawer]="drawer"
        [forestryKml]="mapForestryKml"
        [mapEvents]="mapEvents$.asObservable()"
        [parcels]="mapParcels"
        [site]="activeSite"
        [regionId]="(region || {}).id"
        [currentUser]="currentUser"
        [readOnlyMap]="readOnlyMap"
        [redflagDetails]="redflagDetails"
        [approvalRequired]="isSelectAllDisabled"
        [standListHoverEvents]="standListHover$.asObservable()"></fc-map-layers>
    </ng-container>
  </div>
  <mat-drawer-container [ngClass]="drawer.opened ? 'opened' : 'closed'" hasBackdrop="false">
    <mat-drawer #drawer mode="side" opened="false" position="end">
      <ng-container *ngIf="activeSite">
        <div (click)="drawer.toggle()" class="toggle-button">
          <fa-icon *ngIf="!drawer.opened" [icon]="['fas', 'chevron-left']"></fa-icon>
          <fa-icon *ngIf="drawer.opened" [icon]="['fas', 'chevron-right']"></fa-icon>
        </div>
        <div class="side-panel">
          <div class="side-header">
            <h2>Your Carbon Offset Site</h2>
          </div>
          <div *ngIf="!readOnlyMap" class="select-all">
            <div class="potential">
              Potential Annual Revenue
              <fa-icon
                [icon]="['far', 'circle-info']"
                matTooltip="Potential annual revenue is the estimated amount you could be paid each year if you enroll your entire property. The actual amount may vary based on your periodic attestations and the specifics of your contract terms."
                class="blue"
                matTooltipClass="fc-tooltip"
                matTooltipPosition="right"></fa-icon>
              :
              <br />
              <span class="potential-revenue">
                {{ potentialRevenue }}
              </span>
            </div>
            <span
              [matTooltip]="
                isSelectAllDisabled ? 'In order to change your site, please reject the pending changes first.' : ''
              "
              matTooltipClass="fc-tooltip"
              matTooltipPosition="right">
              <button (click)="selectAll()" [disabled]="isSelectAllDisabled" color="primary" mat-stroked-button>
                Select Entire Property
              </button>
            </span>
          </div>
          <div *ngIf="publicOverlap > 0" class="select-all delete-public">
            <button (click)="deletePublicOverlap()" data-cy="remove-overlap-button" mat-raised-button>
              Remove All Overlap
            </button>
          </div>
          <ng-container *ngIf="selectedStandList?.length; else haveNoSelectedStands">
            <div
              [class.publicLand]="publicOverlap > 0"
              [class.readOnly]="readOnlyMap"
              [class.hasStepper]="activeSite.submittedDate === null && !isAdmin"
              class="stand-list">
              <div
                (mouseenter)="onStandListHoverEvent(true, selectedStand.feature.id)"
                (mouseleave)="onStandListHoverEvent(false, selectedStand.feature.id)"
                *ngFor="let selectedStand of selectedStandList; let i = index">
                <fc-site-stand-item
                  (mapEvent)="onStandListEvent($event)"
                  [allowRemove]="!readOnlyMap"
                  [approvalRequired]="isSelectAllDisabled"
                  [index]="i"
                  [stand]="selectedStand"></fc-site-stand-item>
              </div>
            </div>
          </ng-container>
          <ng-template #haveNoSelectedStands>
            <div class="instruction-container">
              <div class="instruction-title green">How to get started</div>
              <div class="instruction-body">
                Now that you have identified your property, begin adding specific forest areas or stands to your site.
              </div>
              <div class="instruction-body subtitle green">The Fastest and Easiest Way:</div>
              <div class="instruction-with-icon">
                <div class="instruction-icon">
                  <fa-icon [icon]="['fal', 'hand-pointer']" class="icon-button"></fa-icon>
                </div>
                <div class="instruction-body">
                  With the
                  <strong>Selection Tool</strong>
                  highlighted in the tool bar; click on the map to select a forested area of your land, see its carbon
                  value, then decide if you'd like to add it to your Carbon Offset Site.
                </div>
              </div>
              <div class="instruction-body subtitle green">Or, Create Your Own Custom Shapes:</div>
              <div class="instruction-with-icon">
                <div class="instruction-icon">
                  <fa-icon [icon]="['fal', 'pen-nib']" class="icon-button"></fa-icon>
                </div>
                <div class="instruction-body">
                  If you'd like to create your own custom shapes on areas of your property you are considering for
                  enrollment, use the
                  <strong>Draw Tool</strong>
                  .
                </div>
              </div>
              <div class="instruction-with-icon">
                <div class="instruction-icon">
                  <fa-icon [icon]="['fal', 'draw-polygon']" class="icon-button"></fa-icon>
                </div>
                <div class="instruction-body">
                  Use the
                  <strong>Edit Tool</strong>
                  to add, move, or delete nodes of a stand. To select multiple nodes, press shift and click.
                </div>
              </div>
            </div>
          </ng-template>
          <ng-container *ngIf="selectedStandList?.length">
            <div class="submit-section">
              <div class="acres">
                <span>Total Forested Acres: {{ acreage }}</span>
              </div>
              <div class="future-valuations">
                <div class="future-valuation">
                  <span>
                    Estimated Annual Revenue
                    <fa-icon
                      #tooltip1="matTooltip"
                      (click)="tooltip1.toggle()"
                      [icon]="['far', 'circle-info']"
                      matTooltip="Estimated annual revenue is the base payout for the next year of payments. This value can change based on your responses to periodic reporting or on market performance."
                      class="blue"
                      matTooltipClass="fc-tooltip"
                      matTooltipPosition="right"></fa-icon>
                  </span>
                  <span class="valuation">
                    {{ valuationPerYear }}
                  </span>
                </div>
                @if (!readOnlyMap) {
                  @if (!this.isSelectAllDisabled) {
                    <button
                      (click)="handleSaveSite()"
                      *ngIf="!readOnlyMap"
                      [disabled]="!canSaveMap"
                      class="button"
                      color="primary"
                      data-cy="save-and-validate-button"
                      mat-raised-button>
                      Save & Validate Map
                    </button>
                  } @else {
                    <div class="approve-reject-buttons">
                      <button
                        (click)="rejectAdminChanges()"
                        [disabled]="!canSaveMap"
                        color="warn"
                        data-cy="reject-button"
                        mat-raised-button>
                        Reject
                      </button>
                      <button
                        (click)="handleSaveSite()"
                        [disabled]="!canSaveMap"
                        color="primary"
                        data-cy="approve-button"
                        mat-raised-button>
                        Approve
                      </button>
                    </div>
                  }
                }
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </mat-drawer>
  </mat-drawer-container>
</div>
